import { setItemFilterToStore } from 'helpers/utils';

export const filterReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_FILTER':
      if (payload.setInStore) {
        setItemFilterToStore(payload.key, payload.value);
      }
      return {
        ...state,
        [payload.key]: payload.value
      };
    case 'RESET':
      return {
        ...state
      };
    default:
      return state;
  }
};
